import React from 'react';
import PropTypes from 'prop-types';

import { getText } from 'helpers/i18n';
import Text from 'components/Text';

import './select.styles.scss';

/**
 * Select box component
 */
export default class FormSelect extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            options: props.options,
            name: props.name,
            id: props.id,
            onChange: props.onChange,
            defaultValue: props.defaultValue || props.options[0].value,
            validate: props.validate,
            validation: {valid: true, error: ''},
        };
    }

    componentDidMount() {
        const { name, setDefault, options } = this.props;
        if (setDefault && !this.state.defaultValue) {
            setDefault(name, options[0].value);
        }
    }

    componentDidUpdate(prevProps) {
        const { id, name, setDefault, options, noReset } = this.props;
        if (setDefault && prevProps.id !== id && !noReset) {
            this.resetDefaultValue(options, () => {
                setDefault(name, options[0].value);
            });
        }
    }

    onChange(event) {
        const { validator } = this.props;
        const selectedOption = this.state.options[event.target.selectedIndex];

        if (this.props.onChange) {
            this.props.onChange(event.target.name, selectedOption.value, selectedOption);
        }

        // Trigger validation and save result in valid state
        if (this.state.validate) {
            this.setState({ 'validation': this.state.validate(event.target.value, validator)});
        }

        this.setState({ defaultValue: selectedOption.value });
    }

    onBlur = (event) => {
        // Trigger validation and save result in valid state
        if (this.state.validate) {
            this.setState({ 'validation': this.state.validate(event.target.value, this.props.validator) });
        }
    }

    static getDerivedStateFromProps(props) {
        return props;
    }

    renderError() {
        if (!this.state.validation.valid) {
            const options = this.state.validation.textParams || null;
            return (
                <p className="error-helper" id={this.props.id + '_error'}>
                    <Text textKey={this.state.validation.error} options={options} />
                </p>
            );
        }

        return null;
    }

    render() {
        const { name, id, ariaLabel, parseText, ariaRequired } = this.props;
        let errorClass = '';

        if (!this.state.validation.valid) {
            errorClass = 'error-input';
        }
        return (
            <>
                <select
                    className={errorClass}
                    name={name}
                    onChange={this.onChange.bind(this)}
                    id={id}
                    value={this.state.defaultValue}
                    title={ariaLabel}
                    aria-label={ariaLabel}
                    aria-required={ariaRequired}
                    aria-describedby={!this.state.validation.valid ? this.props.id + '_error' : ''}
                    aria-invalid={!this.state.validation.valid}
                >
                    {
                        this.state.options.map((option) => { // Iterate and add the options
                            return <option key={option.value} value={option.value}>
                                { (parseText && option.textKey) ?
                                    getText(option.textKey) :
                                    option.name
                                }
                            </option>;
                        })
                    }
                </select>
                {this.renderError()}
            </>
        );
    }

    resetDefaultValue(options, callback) {
        const { defaultValue } = this.props;
        this.setState({
            defaultValue: defaultValue || options[0].value,
        }, callback);
        return;
    }
}

FormSelect.propTypes = {
    /** Options [{name:'Option 1', value: '1'}, {name:'Option 2', value:'2'}] */
    options: PropTypes.array.isRequired,
    /** Text describing the select box to screen readers */
    ariaLabel: PropTypes.string.isRequired,
    name: PropTypes.string,
    id: PropTypes.string,
    /** Callback function triggered when value changes */
    onChange: PropTypes.func,
    /** Default selected value */
    defaultValue: PropTypes.any,
    parseText: PropTypes.bool,
    setDefault: PropTypes.func,
    ariaRequired: PropTypes.bool,
    validate: PropTypes.func,
    validator: PropTypes.object,
    noReset: PropTypes.bool,
};
